"use strict";
const FORCE_INLINE_PDF_VIEWER = false;
const ALERT_SUCCESS = 'success';
const ALERT_WARNING = 'warning';
const ALERT_ERROR = 'error';
const ALERT_INFO = 'info';
const ALERT_QUESTION = 'question';
const ALERT_NONE = '';
const AREA_DOCUMENTS = "2A1BC314-4142-41C1-B7A5-378C61EA11A0";
const AREA_POSTS = "442AEA45-DA58-4AF1-8A47-297CD5268462";
const AREA_SANCTIONS = "1D6EBFB0-AB1F-42AA-815E-2E3D96BF33DC";
const AREA_PROFILE = "76D4D8F6-D091-413F-840B-99534D0DA038";
const AREA_REQUESTS = "24C1C18F-DC3C-404B-A019-29069F23D3AE";
const AREA_TIME_CONTROL = "876016C3-9EAD-4F23-8578-5B9293D22C47";
const AREA_VACATIONS = "E228B621-8367-4526-8153-A92C8D9FD2B9";
const AREA_LEAVES = "A5007624-4493-465A-A2B8-0C25EF03D5FB";
const ATTACHMENT_COPIED_STATUS_UNKNOWN = 0;
const ATTACHMENT_COPIED_STATUS_NOT_COPIED = 1;
const ATTACHMENT_COPIED_STATUS_COPIED_IN_PROFILE = 2;
const ATTENDANCE_STATUS_ABSENT = 0;
const ATTENDANCE_STATUS_PARTIAL = 1;
const ATTENDANCE_STATUS_PRESENT = 2;
const ATTENDANCE_STATUS_LEAVE = 3;
const BATCH_SIGNED_STATUS_ANY = 0;
const BATCH_SIGNED_STATUS_ALL_SIGNED = 1;
const BATCH_SIGNED_STATUS_SIGNED_INCOMPLETE = 2;
const CALENDAR_DEFAULT_INTERVAL_MONTHS = 12;
const DEFAULT_AVATAR = "/images/default-avatar.png";
const DEFAULT_CULTURE = "es-AR";
const DEFAULT_LANGUAGE = "es";
const DOCUMENT_SIGNED_STATUS_UNSIGNED = 0;
const DOCUMENT_SIGNED_STATUS_SIGNED_IN_COMFORMITY = 1;
const DOCUMENT_SIGNED_STATUS_SIGNED_WITH_OBJECTIONS = 2;
const FONT_FAMILY = "Poppins";
const ICON_AUTH_UNIT = "hricon-network-communication";
const ICON_GROUP = "hricon-meeting";
const ICON_USER = "hricon-single-05";
const MATCH_USER = 0;
const MATCH_GROUP = 1;
const MATCH_BATCH = 2;
const MATCH_DOCUMENT = 3;
const MATCH_REQUEST = 4;
const MATCH_REQUEST_REPLY = 5;
const MATCH_REQUEST_ATTACHMENT = 6;
const MATCH_PROFILE_DOC = 7;
const MATCH_ONBOARDING_DOC = 8;
const MATCH_POST = 9;
const MATCH_LEAVES = 10;
const MATCH_VACATIONS = 11;
const MESSAGE_TYPE_BROADCAST = 0;
const MESSAGE_TYPE_COMPANY_NEWS = 1;
const MESSAGE_TYPE_NEW_DOCUMENT_RECEIVED = 2;
const MESSAGE_TYPE_NEW_SANCTION_RECEIVED = 3;
const MESSAGE_TYPE_NEW_REQUEST_FROM_EMPLOYEE_RECEIVED = 4;
const MESSAGE_TYPE_NEW_REQUEST_FROM_COMPANY_RECEIVED = 5;
const MESSAGE_TYPE_NEW_REQUEST_REPLY_FROM_EMPLOYEE_RECEIVED = 6;
const MESSAGE_TYPE_NEW_REQUEST_REPLY_FROM_COMPANY_RECEIVED = 7;
const MESSAGE_TYPE_NEW_REQUEST_CANCELLATION_RECEIVED = 8;
const MESSAGE_TYPE_REQUEST_ACCEPTED = 9;
const MESSAGE_TYPE_REQUEST_REJECTED = 10;
const MESSAGE_TYPE_REQUEST_CANCELLED = 11;
const MESSAGE_TYPE_ONBOARDING_ITEMS_COMPLETED = 12;
const MESSAGE_TYPE_NEW_POST_FROM_COMPANY = 13;
const MESSAGE_TYPE_POST_DELETED = 14;
const MESSAGE_TYPE_DOCUMENT_ITEM_SIGNED = 15;
const MESSAGE_TYPE_SANCTION_ITEM_SIGNED = 16;
const MESSAGE_TYPE_ONBOARDING_ITEM_SIGNED = 17;
const MESSAGE_TYPE_REQUEST_REOPENED = 18;
const MESSAGE_TYPE_NEW_REQUEST_REPLY_FROM_AUTH_UNIT_RESP_RECEIVED = 19;
const MESSAGE_NEW_FORM_RECEIVED = 20;
const PROFILE_DOCUMENT_NOT_EXPIRED = 0;
const PROFILE_DOCUMENT_IN_EXPIRATION_WINDOW = 1;
const PROFILE_DOCUMENT_EXPIRED = 2;
const REQUEST_STATUS_INITIATED = 0;
const REQUEST_STATUS_IN_REVISION = 1;
const REQUEST_STATUS_CANCEL_PENDING = 2;
const REQUEST_STATUS_ACCEPTED = 3;
const REQUEST_STATUS_REJECTED = 4;
const REQUEST_STATUS_APPROVED_BY_RESPONSIBLE = 5;
const REQUEST_STATUS_REJECTED_BY_RESPONSIBLE = 6;
const SECURITY_PRINCIPAL_USER = 1;
const SECURITY_PRINCIPAL_GROUP = 2;
const SECURITY_PRINCIPAL_AUTH_UNIT = 4;
const USER_SETTINGS_NAME_MAX_LENGTH = 30;
const WORKAGREEMENT_ALLOWED_LEAVE_DAYS_VALIDITY_CALENDAR_YEAR = 0;
const WORKAGREEMENT_ALLOWED_LEAVE_DAYS_VALIDITY_SLIDING_WINDOW = 1;
const WORKING_HOUR_EVENT_TYPE_NONE = 0;
const WORKING_HOUR_EVENT_TYPE_WORKING_HOUR = 1;
const WORKING_HOUR_EVENT_TYPE_PAUSE = 2;
const WORKING_HOUR_ACTION_TYPE_START = 0;
const WORKING_HOUR_ACTION_TYPE_PAUSE = 1;
const WORKING_HOUR_ACTION_TYPE_RESUME = 2;
const WORKING_HOUR_ACTION_TYPE_STOP = 3;
const DOCUMENT_TARGET_USERS_WARNING_THRESHOLD = 10;
const REQUEST_TARGET_USERS_WARNING_THRESHOLD = 10;
window._globalizeLoaded = false;
jQuery.expr[':'].Contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};
function setCookie(c_name, value, exdays) {
    if (!exdays)
        exdays = 730;
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = encodeURIComponent(value) + ((exdays === null || exdays === undefined) ? "" : "; expires=" + exdate.toUTCString() + ";SameSite=Lax");
    document.cookie = c_name + "=" + c_value + ";path=/";
}
function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substring(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substring(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x === c_name) {
            return decodeURIComponent(y);
        }
    }
}
function formatJsonDateForInput(jsonDate) {
    var d = new Date(jsonDate);
    var s = d.toISOString().substring(0, 10);
    return s;
}
function formatDateObjectForInput(d) {
    var s = d.toISOString().substring(0, 10);
    return s;
}
function getFilenameInfo(filename) {
    if (!filename)
        return "";
    var fileIcon = "";
    var attClass = "";
    var nativeView = false;
    var fn = "";
    var ext = "";
    var dot = filename.lastIndexOf(".");
    if (dot === -1) {
        fn = filename;
        ext = "";
    }
    else {
        fn = filename.substring(0, dot);
        ext = filename.substring(dot + 1).toLowerCase();
    }
    if (ext === "pdf") {
        fileIcon = "hricon hricon-file-pdf";
        attClass = "attachment-pdf";
        nativeView = true;
    }
    else if (ext === "jpg" || ext === "jpeg") {
        fileIcon = "hricon hricon-file-jpg";
        attClass = "attachment-jpg";
        nativeView = true;
    }
    else if (ext === "tif" || ext === "tiff") {
        fileIcon = "hricon hricon-file-tiff";
        attClass = "attachment-tif";
        nativeView = false;
    }
    else if (ext === "doc" || ext === "docx") {
        fileIcon = "hricon hricon-file-docx";
        attClass = "attachment-doc";
        nativeView = true;
    }
    else if (ext === "xls" || ext === "xlsx") {
        fileIcon = "hricon hricon-file-xlsx";
        attClass = "attachment-xls";
        nativeView = false;
    }
    else if (ext === "bmp") {
        fileIcon = "hricon hricon-file-bmp";
        attClass = "attachment-bmp";
        nativeView = true;
    }
    else if (ext === "png") {
        fileIcon = "hricon hricon-file-png";
        attClass = "attachment-png";
        nativeView = true;
    }
    else if (ext === "txt") {
        fileIcon = "hricon hricon-file-txt";
        attClass = "attachment-txt";
        nativeView = true;
    }
    else {
        fileIcon = "hricon hricon-file-question";
        attClass = "attachment-other";
        nativeView = false;
    }
    return {
        filename: fn,
        extension: ext,
        icon: fileIcon,
        class: attClass,
        nativeView: nativeView
    };
}
function disablePinchZoom() {
    document.addEventListener('touchmove', function (event) {
        if (('scale' in event) && event.scale !== 1) {
            event.preventDefault();
        }
    }, false);
    document.addEventListener("gesturestart", function (e) {
        e.preventDefault();
        document.body.style.zoom = 0.99;
    });
    document.addEventListener("gesturechange", function (e) {
        e.preventDefault();
        document.body.style.zoom = 0.99;
    });
    document.addEventListener("gestureend", function (e) {
        e.preventDefault();
        document.body.style.zoom = 1;
    });
}
function supportsPDFViewer() {
    if (FORCE_INLINE_PDF_VIEWER)
        return false;
    var bn = getBrowserInfo();
    var sups = ["chrome", "firefox", "edge", "safari"];
    if (sups.includes(bn.userAgent) && !bn.mobile)
        return true;
    else
        return false;
}
function getBrowserInfo() {
    var userAgent = navigator ? navigator.userAgent.toLowerCase() : "other";
    var ua = userAgent;
    if (userAgent.indexOf("chrome") > -1)
        ua = "chrome";
    else if (userAgent.indexOf("safari") > -1)
        ua = "safari";
    else if (userAgent.indexOf("msie") > -1)
        ua = "ie";
    else if (userAgent.indexOf("firefox") > -1)
        ua = "firefox";
    else if (userAgent.indexOf("edge") > -1)
        ua = "edge";
    else if (userAgent.indexOf("opera") > -1)
        ua = "opera";
    var mobile = userAgent.toLowerCase().indexOf("mobile") >= 0;
    return { userAgent: ua, mobile: mobile };
}
function getFileExtension(filename) {
    if (!filename)
        return "";
    var ext = filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
    if (ext)
        return `.${ext}`;
    return ext;
}
function triggerDownload(document, url, filename) {
    filename = filename ?? "download";
    var a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    a.click();
}
function getFileWithoutPath(fullPath) {
    if (fullPath) {
        var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
        var filename = fullPath.substring(startIndex);
        if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
            filename = filename.substring(1);
        }
        return filename;
    }
}
function showOverlay(text) {
    if (text === null || text === undefined)
        text = Messages.OverlayWaiting;
    if (text)
        document.querySelector(".overlay .overlay-text").textContent = text;
    document.querySelector(".overlay").classList.add("active");
}
function hideOverlay() {
    document.querySelector(".overlay").classList.remove("active");
}
function showToast(data, title, toastType = ALERT_ERROR, options = null) {
    var m = "";
    var t;
    if (title)
        t = title;
    if (!t) {
        if (toastType !== ALERT_ERROR) {
            if (toastType === ALERT_SUCCESS || toastType === ALERT_INFO)
                t = Messages.ToastInfo;
            else
                t = Messages.ToastWarning;
        }
        else
            t = Messages.ToastError;
    }
    if (!data) {
        m = "Called showToast without a message";
    }
    else {
        if (typeof data === "string") {
            m = data;
        }
        else {
            if (data.IsResponsePageResult) {
                PopupAjaxError(data.Message);
                return;
            }
            if (!data.Message)
                m = "Called ShowToast with a response object that has no message";
            else
                m = data.Message;
            if (data.SessionExpired)
                setTimeout(function () {
                    location.href = "/account/login";
                }, 3000);
        }
    }
    if (m && m.length > 300)
        m = m.substring(0, 300) + "...";
    var tl = m.length;
    var dur = Math.round(tl / 10);
    if (dur < 4)
        dur = 4;
    else if (dur > 10)
        dur = 10;
    while (m.indexOf("\r\n") >= 0)
        m = m.replace("\r\n", "<br/>");
    if (!options)
        options = {};
    if (options.toast === undefined)
        options.toast = true;
    if (options.position === undefined)
        if (!getBrowserInfo().mobile)
            options["position"] = 'bottom-end';
        else
            options["position"] = 'top';
    if (options.timer === undefined) {
        options["timer"] = dur * 1000;
        options["timerProgressBar"] = true;
    }
    if (options.timer === 0)
        options["showConfirmButton"] = true;
    if (!options.showConfirmButton)
        options["showConfirmButton"] = false;
    if (!options.confirmButtonText)
        options["confirmButtonText"] = Messages.ButtonAccept;
    if (!options.showCloseButton)
        options["showCloseButton"] = true;
    options["didOpen"] = (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    };
    options["icon"] = toastType;
    options["html"] = m;
    var resp = Swal.fire(options);
    if (options.onclick) {
        resp.then((result) => {
            options.onclick();
        });
    }
}
function showAlert(text, title, alertType = ALERT_SUCCESS, options = null) {
    var m = "";
    var t;
    if (title !== undefined)
        t = title;
    if (t === null || t === undefined) {
        if (alertType !== ALERT_ERROR) {
            if (alertType === ALERT_SUCCESS || alertType === ALERT_INFO)
                t = Messages.ToastInfo;
            else
                t = Messages.ToastWarning;
        }
        else
            t = Messages.ToastError;
    }
    if (!text) {
        m = "Called showAlert without a message";
    }
    else {
        m = text;
    }
    while (m.indexOf("\r\n") >= 0)
        m = m.replace("\r\n", "<br/>");
    if (!options)
        options = {};
    options.title = t;
    options.toast = false;
    options.position = 'center';
    options.timer = undefined;
    if (options.showConfirmButton === undefined)
        options["showConfirmButton"] = true;
    if (!options.confirmButtonText)
        options["confirmButtonText"] = Messages.ButtonAccept;
    if (options.showCancelButton === undefined)
        options["showCancelButton"] = false;
    if (!options.cancelButtonText)
        options["cancelButtonText"] = Messages.ButtonCancel;
    if (options.showDenyButton === undefined)
        options["showDenyButton"] = false;
    if (!options.denyButtonText)
        options["denyButtonText"] = Messages.ButtonDeny;
    if (!options.showCloseButton)
        options["showCloseButton"] = false;
    if (!options.allowOutsideClick)
        options["allowOutsideClick"] = false;
    options["icon"] = alertType;
    options["html"] = m;
    var onConfirm = options.onConfirm;
    var onDismiss = options.onDismiss;
    var onDeny = options.onDeny;
    if (options.onConfirm)
        delete options.onConfirm;
    if (options.onDismiss)
        delete options.onDismiss;
    if (options.onDeny)
        delete options.onDeny;
    Swal.fire(options).then((result) => {
        if (result.isConfirmed && onConfirm)
            onConfirm();
        else if (result.isDenied && onDeny)
            onDeny();
        else if (result.isDismissed && onDismiss)
            onDismiss();
    });
}
function PopupAjaxError(html) {
    var w = window.open('');
    if (w)
        w.document.write(html);
    else
        alert(Messages.DisablePopupBlockers);
}
async function loadCldr(culture) {
    if (!culture)
        culture = getCulture();
    var cldr = [
        `/lib/cldr/supplemental/numberingSystems.json`,
        `/lib/cldr/main/${culture}/numbers.json`,
        `/lib/cldr/main/${culture}/timeZoneNames.json`,
        `/lib/cldr/main/${culture}/ca-gregorian.json`
    ];
    var p = [];
    var jsons = [];
    cldr.map(x => {
        p.push(fetch(x).then(async (r) => {
            jsons.push(await r.json());
        }));
    });
    await Promise.all(p);
    return jsons;
}
async function setupGlobalize(culture) {
    if (!culture)
        culture = getCulture();
    var g, gjson;
    await Promise.all([
        fetch("/lib/cldr/supplemental/likelySubtags.json").then((r) => r.json()),
        fetch("/lib/cldr/supplemental/timeData.json").then((r) => r.json()),
        fetch("/lib/cldr/supplemental/numberingSystems.json").then((r) => r.json()),
        fetch("/lib/cldr/supplemental/currencyData.json").then((r) => r.json()),
        fetch("/lib/cldr/supplemental/plurals.json").then((r) => r.json()),
        fetch("/lib/cldr/main/" + culture + "/languages.json").then((r) => r.json()),
        fetch("/lib/cldr/main/" + culture + "/numbers.json").then((r) => r.json()),
        fetch("/lib/cldr/main/" + culture + "/ca-gregorian.json").then((r) => r.json())
    ]).then(function (json) {
        Globalize.load(json);
        g = Globalize(culture);
        gjson = json;
    });
    return { globalize: g, json: gjson };
}
function hexToInt(val) {
    if (val.length < 1)
        return NaN;
    if (val.length > 2)
        return NaN;
    if (val.length === 1)
        val = "0" + val;
    var n = 0;
    var h = val.substring(0, 1).toUpperCase();
    if (h >= 'A' && h <= 'F')
        n = 10 + h.charCodeAt(0) - 65;
    else
        n = parseInt(h, 10);
    n *= 16;
    h = val.substring(1, 2).toUpperCase();
    if (h >= 'A' && h <= 'F')
        n += 10 + h.charCodeAt(0) - 65;
    else
        n += parseInt(h, 10);
    return n;
}
function colorHtmlToArray(color) {
    if (color.startsWith("#"))
        color = color.substring(1);
    return [hexToInt(color.substring(0, 2)), hexToInt(color.substring(2, 4)), hexToInt(color.substring(4, 6))];
}
function arrayToHtmlColors(values) {
    if (!values || values.length < 3 || values.length > 4)
        return "#000000";
    var c = "#";
    values.forEach(v => {
        c += v.toString(16).padStart(2, "0");
    });
    return c;
}
function rgbToHsl(values) {
    var r = values[0] / 255, g = values[1] / 255, b = values[2] / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max === min) {
        h = s = 0;
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return [h * 360, s * 100, l * 100];
}
function hslToRgb(h, s, l) {
    h /= 360; s /= 100; l /= 100;
    var r, g, b;
    if (s === 0) {
        r = g = b = l;
    } else {
        var hue2rgb = function (p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}
function lighten(color, amount) {
    var rgb = colorHtmlToArray(color);
    var hsl = rgbToHsl(rgb);
    hsl[2] = Math.min(100, Math.max(0, hsl[2] + amount * 100));
    return arrayToHtmlColors(hslToRgb(hsl[0], hsl[1], hsl[2]));
}
function darken(color, amount) {
    var rgb = colorHtmlToArray(color);
    var hsl = rgbToHsl(rgb);
    hsl[2] = Math.min(100, Math.max(0, hsl[2] - amount * 100));
    return arrayToHtmlColors(hslToRgb(hsl[0], hsl[1], hsl[2]));
}
function flattenOpacity(color, backgroundColor, opacity) {
    var fg = colorHtmlToArray(color);
    var bg = colorHtmlToArray(backgroundColor);
    var blended = fg.map((c, i) => Math.round(c * opacity + bg[i] * (1 - opacity)));
    return arrayToHtmlColors(blended);
}
function getLuminanace(values) {
    const rgb = values.map((v) => {
        const val = v / 255;
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(colorA, colorB) {
    const lumA = getLuminanace(colorA);
    const lumB = getLuminanace(colorB);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function getThemeColor(name) {
    var e = document.querySelector(":root");
    return getComputedStyle(e).getPropertyValue("--xignable-" + name);
}
function getBestForegroundColor(bgColor) {
    var bcr = getContrastRatio(bgColor, colorHtmlToArray(color_black));
    var wcr = getContrastRatio(bgColor, colorHtmlToArray(color_white));
    var fc;
    if (wcr < 2.25)
        fc = bcr > wcr ? color_black : color_white;
    else
        fc = color_white;
    return fc;
}
function getVariableValue(name) {
    var e = document.querySelector(":root");
    return getComputedStyle(e).getPropertyValue(name);
}
function isToday(someDate, today) {
    if (!today)
        today = new Date();
    return someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear();
}
function getMonthName(month, localeName = 'es-AR', abbreviated) {
    abbreviated = !!abbreviated;
    var names = getMonthsForLocale(localeName);
    var m = names[month - 1];
    if (abbreviated && m)
        m = m.substring(0, 3);
    return m;
}
function getMonthsForLocale(localeName = 'es-AR', monthFormat = 'long') {
    const format = new Intl
        .DateTimeFormat(localeName, { month: monthFormat }).format;
    return [...Array(12).keys()]
        .map((m) => format(new Date(Date.UTC(2023, (m + 1) % 12))));
}
function getDayName(day, localeName = 'es-AR') {
    var names = getDaysForLocale(localeName);
    return names[day % 7];
}
function getDaysForLocale(localeName = 'es-AR', dayFormat = 'long') {
    const format = new Intl
        .DateTimeFormat(localeName, { weekday: dayFormat }).format;
    return [...Array(7).keys()]
        .map((d) => format(new Date(Date.UTC(2001, 0, d + 1))));
}
function getFirstDayCurrentMonth() {
    const today = new Date();
    var y = today.getFullYear();
    var m = today.getMonth();
    var d = 1;
    return new Date(y, m, d);
}
function getFirstDayPastMonth() {
    const today = new Date();
    var y = today.getFullYear();
    var m = today.getMonth();
    var d = 1;
    m--;
    if (m < 0) {
        m = 11;
        y--;
    }
    return new Date(y, m, d);
}
function getDateWithoutTime(date) {
    var d = "";
    if (typeof (date) === "object")
        d = date.toJSON();
    else
        d = date;
    return d.slice(0, 10);
}
function getUserStatusText(status) {
    if (status === 0)
        return Messages.UserStatusCreated;
    else if (status === 1)
        return Messages.UserStatusActive;
    else if (status === 2)
        return Messages.UserStatusRestricted;
    else if (status === 3)
        return Messages.UserStatusOnboarding;
    else if (status === 4)
        return Messages.UserStatusDisabled;
    else
        return "?";
}
function getCompanyStatusText(status) {
    if (status === 0)
        return Messages.CompanyStatusInactive;
    else if (status === 1)
        return Messages.CompanyStatusActive;
    else if (status === 2)
        return Messages.CompanyStatusRestricted;
    else if (status === 3)
        return Messages.CompanyStatusAdminActivationPending;
    else
        return "?";
}
function toggleSidebar(show) {
    if (show) {
        $("body > .container-fluid").removeClass("sidebar-collapsed");
        $(".page-header").removeClass("d-none");
    }
    else {
        $("body > .container-fluid").addClass("sidebar-collapsed");
        $(".page-header").addClass("d-none");
        $(".container-fluid.sidebar-collapsed .sidebar-expander").click(function () {
            $(this).parents(".sidebar-collapsed").addClass("sidebar-collapse-hover");
        });
        $(".container-fluid.sidebar-collapsed main").on("mouseenter", function () {
            $(this).parents(".sidebar-collapsed").removeClass("sidebar-collapse-hover");
        });
    }
}
function convertCssPxToInt(cssPxValueText) {
    if (!cssPxValueText)
        cssPxValueText = "";
    var validChars = "0123456789.";
    var convertedValue = 0;
    for (var i = 0; i < cssPxValueText.length; i++) {
        if (validChars.indexOf(cssPxValueText.charAt(i)) === -1) {
            if (i > 0) {
                convertedValue = parseInt(cssPxValueText.substring(0, i), 10);
                return convertedValue;
            }
        }
    }
    return convertedValue;
}
function convertRemToPixels(rem) {
    return parseFloat(rem, 10) * parseFloat(getComputedStyle(document.documentElement).fontSize);
}
function activateSF() {
    var k = document.getElementById("_sf").value;
    ej.base.registerLicense(k);
}
async function loadSFGlobalize() {
    if (!window._globalizeLoaded) {
        var lang = getLanguage();
        var jsons = await loadCldr(lang);
        ej.base.loadCldr(...jsons);
        if (lang && lang !== "en") {
            var response = await fetch(`/lib/ej2/es.json`);
            var json = await response.json();
            ej.base.L10n.load(json);
        }
        window._globalizeLoaded = true;
    }
}
function getLanguage() {
    var l = document.getElementById("_language").value;
    return l ? l : DEFAULT_LANGUAGE;
}
function getCulture() {
    var c = document.getElementById("_culture").value;
    return c ? c : DEFAULT_CULTURE;
}
function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
function getUserSuggestionString(data) {
    var icon = `<span class='hricon ${ICON_USER}'></span>`;
    var s = `<div>${icon} ${data.UIName}`;
    var s2 = "";
    if (data.IdNumber || data.TaxpayerId || data.EmployeeNumber || data.Email) {
        if (data.EmployeeNumber)
            s2 += `${Messages.EmployeeNumber} ${data.EmployeeNumber}`;
        if (data.IdNumber) {
            if (s2.length > 0)
                s2 += ", ";
            s2 += `${Messages.IdNumber} ${data.IdNumber}`;
        }
        if (data.TaxpayerId) {
            if (s2.length > 0)
                s2 += ", ";
            s2 += `${Messages.TaxpayerId} ${data.TaxpayerId}`;
        }
        if (data.Email) {
            if (s2.length > 0)
                s2 += ", ";
            s2 += `${data.Email}`;
        }
        if (s2)
            s2 = " (" + s2 + ")";
    }
    s += s2 + "</div>";
    return s;
}
function getAuthUnitSuggestionString(data) {
    var icon = `<span class='hricon ${ICON_AUTH_UNIT}'></span>`;
    var s = `<div>${icon} ${data.Name} (${Messages.AuthUnitLevel}${data.Level})</div>`;
    s += "</div>";
    return s;
}
function getTeamSuggestionString(data) {
    var icon = `<span class='hricon ${ICON_GROUP}'></span>`;
    var s = `<div>${icon} ${data.Name}</div>`;
    return s;
}
function getSecurityPrincipalSuggestionString(data) {
    if (data.Type === SECURITY_PRINCIPAL_AUTH_UNIT)
        return getAuthUnitSuggestionString(data);
    else if (data.Type === SECURITY_PRINCIPAL_GROUP)
        return getTeamSuggestionString(data);
    else
        return getUserSuggestionString(data);
}
function scrollBodyToBottom(deferredTimeout) {
    var s = function () {
        window.scrollTo({
            left: 0,
            top: document.body.scrollHeight,
            behavior: "smooth"
        });
    };
    if (deferredTimeout)
        setTimeout(s, deferredTimeout);
    else
        s();
}
function handleColumnSort(key, keyArray, $el, e, tableHeaderSelector) {
    var ds = findSortInfo(key, keyArray);
    if (ds) {
        ds.desc = !ds.desc;
        if (ds.desc === false) {
            keyArray = keyArray.filter((x) => x.key !== key);
            window.Site.addHeaderSort($el, null);
        }
        else {
            if (!e.ctrlKey) {
                keyArray = [];
                keyArray.push(ds);
                window.Site.addHeaderSort($el, ds.desc, tableHeaderSelector);
            }
            else {
                window.Site.addHeaderSort($el, ds.desc);
            }
        }
    }
    else {
        if (!e.ctrlKey) {
            keyArray = [];
            window.Site.removeAllHeadersSort(tableHeaderSelector);
        }
        ds = { key: key, desc: false };
        keyArray.push(ds);
        window.Site.addHeaderSort($el, ds.desc);
    }
    return keyArray;
}
function findSortInfo(key, arr) {
    var ret = null;
    arr.forEach((val, idx) => {
        if (val.key === key) {
            ret = val;
            return false;
        }
    });
    return ret;
}
function dateFromString(dt) {
    if (!dt)
        return dt;
    if (typeof dt !== "string")
        return dt;
    var z = dt.indexOf("Z");
    if (z >= 0)
        dt = dt.replace("Z", "");
    return new Date(dt);
}
function minutesFormatted(sec) {
    var m = "00", s = "0";
    if (sec && sec > 0) {
        m = parseInt(Math.floor(sec / 60), 10);
        var rem = sec - m * 60;
        s = ("00" + rem).slice(-2, 4);
    }
    return `${m}m ${s}s`;
}
function hoursFormatted(sec) {
    var m = 0, h = 0, mm = "";
    if (sec && sec > 0) {
        m = parseInt(Math.floor(sec / 60), 10);
        if (m >= 60)
            h = parseInt(Math.floor(m / 60), 10);
        var rem = m - h * 60;
        mm = ("00" + rem.toString()).slice(-2, 4);
    }
    if (m === 0) {
        if (h === 0)
            return "0h";
        else
            return `${h}h`;
    }
    else
        return h > 0 ? `${h}h ${mm}m` : `${mm}m`;
}
function dateDiffDays(dt1, dt2) {
    const diffTime = Math.abs(dt2 - dt1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}
function dateDiffFormatted(dt1, dt2) {
    dt1 = dateFromString(dt1);
    dt2 = dateFromString(dt2);
    var m = dateDiffMinutes(dt1, dt2);
    var h = 0;
    if (m >= 60)
        h = parseInt(Math.floor(m / 60), 10);
    var rem = m - h * 60;
    var mm = ("00" + rem.toString()).slice(-2, 4);
    if (m === 0)
        return `${h}h ${mm}m`;
    else
        return h > 0 ? `${h}h ${mm}m` : `${mm}m`;
}
function dateDiffMinutes(dt2, dt1) {
    var diff = dateDiffSeconds(dt1, dt2);
    diff /= 60;
    return Math.abs(Math.round(diff));
}
function dateDiffSeconds(dt2, dt1) {
    dt1 = dateFromString(dt1);
    dt2 = dateFromString(dt2);
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    return Math.abs(Math.round(diff));
}
function validateTimeFormat(t) {
    if (!t || t.length !== 5 || t.indexOf(":") !== 2)
        return -1;
    var h = parseInt(t.substring(0, 2), 10);
    if (h < 0 || h > 23)
        return -1;
    var m = parseInt(t.substring(3, 5), 10);
    if (m < 0 || m > 59)
        return -1;
    return h * 60 + m;
}
function parseHTML(html) {
    var t = document.createElement('template');
    t.innerHTML = html;
    return t.content;
}
function RenderPieChart(chartOptions) {
    if (!chartOptions)
        return;
    if (!chartOptions.chartData || chartOptions.chartData.length === 0)
        return;
    chartOptions = sanitizeChartOptions(chartOptions);
    ej.charts.AccumulationChart.Inject(ej.charts.AccumulationLegend, ej.charts.AccumulationDataLabel, ej.charts.AccumulationTooltip);
    var chart = new ej.charts.AccumulationChart({
        series: [
            {
                animation: {
                    enable: chartOptions.animationEnabled,
                    duration: chartOptions.animationDuration
                },
                alignment: 'Left',
                legendShape: 'Circle',
                dataSource: chartOptions.chartData,
                border: {
                    width: 1,
                },
                xName: 'x',
                yName: 'y',
                startAngle: 45,
                radius: '100%',
                innerRadius: '75%',
                name: chartOptions.title,
            }
        ],
        position: "left",
        height: chartOptions.height,
        enableSmartLabels: true,
        centerLabel: {
            text: chartOptions.centerLabel,
            textStyle: {
                fontWeight: '400',
                fontFamily: FONT_FAMILY,
                size: '2.8rem',
                color: chartOptions.colors.centerLabelColor
            },
        },
        enableBorderOnMouseMove: false,
        legendSettings: {
            visible: false,
        },
        tooltip: {
            enable: true,
            textStyle: {
                fontWeight: '200',
                fontFamily: FONT_FAMILY,
                color: chartOptions.colors.tooltipColor
            },
        },
        pointRender: function (args) {
            args.fill = chartOptions.chartData[args.point.index].color;
            args.border.color = chartOptions.colors.border;
        },
    });
    return chart;
}
function RenderHorizontalStackedBarChart(chartOptions) {
    if (!chartOptions)
        return;
    if (!chartOptions.chartData || chartOptions.chartData.length === 0)
        return;
    chartOptions = sanitizeChartOptions(chartOptions);
    ej.charts.AccumulationChart.Inject(ej.charts.AccumulationLegend, ej.charts.AccumulationDataLabel, ej.charts.AccumulationTooltip);
    var series = [];
    var setLeftBorder = false;
    var leftSet = false;
    var rightBorderCandidateIdx = -1;
    chartOptions.chartData.forEach((val, idx) => {
        setLeftBorder = false;
        if (val[0].y > 0) {
            if (!leftSet) {
                setLeftBorder = true;
                leftSet = true;
            }
            rightBorderCandidateIdx = idx;
        }
        series.push({
            animation: {
                enable: chartOptions.animationEnabled,
                duration: chartOptions.animationDuration
            },
            type: 'StackingBar100',
            name: val[0].name,
            fill: val[0].color,
            cornerRadius: {
                topLeft: setLeftBorder ? chartOptions.cornerRadius : 0,
                bottomLeft: setLeftBorder ? chartOptions.cornerRadius : 0,
                topRight: 0,
                bottomRight: 0
            },
            dataSource: chartOptions.chartData[idx],
            xName: 'x',
            yName: 'y',
            columnWidth: 0.3
        });
        if (idx === chartOptions.chartData.length - 1 && rightBorderCandidateIdx >= 0) {
            series[rightBorderCandidateIdx].cornerRadius.topRight = chartOptions.cornerRadius;
            series[rightBorderCandidateIdx].cornerRadius.bottomRight = chartOptions.cornerRadius;
        }
    });
    var chart = new ej.charts.Chart({
        primaryXAxis: {
            valueType: 'Category',
            majorGridLines: { width: 0 },
            majorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            labelStyle: {
                fontWeight: '200',
                fontFamily: FONT_FAMILY,
                color: chartOptions.colors.xAxisLabelColor
            },
        },
        primaryYAxis: {
            visible: false,
            edgeLabelPlacement: 'Shift',
            title: '',
            majorGridLines: { width: 0 },
            majorTickLines: { width: 0 },
            lineStyle: { width: 0 },
            labelStyle: {
                fontWeight: '200',
                fontFamily: FONT_FAMILY,
                color: chartOptions.colors.yAxisLabelColor
            },
        },
        chartArea: {
            border: {
                width: 0
            }
        },
        series: series,
        width: chartOptions.width,
        legendSettings: {
            visible: chartOptions.legendVisible,
            shapeWidth: 6,
            shapeHeight: 6,
            shapePadding: 10,
            itemPadding: 30,
            textStyle: {
                fontWeight: '200',
                fontFamily: FONT_FAMILY,
                size: "0.8rem",
                color: chartOptions.colors.tooltipColor
            },
        },
        tooltip: {
            enable: true,
            tipPointerPosition: "Middle",
            format: chartOptions.tooltipFormat ? chartOptions.tooltipFormat : '${point.y} (${point.percentage}%)',
            textStyle: {
                fontWeight: '200',
                fontFamily: FONT_FAMILY,
                color: chartOptions.colors.tooltipColor
            },
        },
        pointRender: function (args) {
            args.border.width = 1;
            args.border.color = chartOptions.colors.border;
        },
    });
    return chart;
}
function RenderTimeControlChart(chartOptions) {
    if (!chartOptions)
        return;
    if (!chartOptions.chartData || chartOptions.chartData.length === 0)
        return;
    if (!chartOptions.colors)
        chartOptions.colors = {};
    if (!chartOptions.colors.border)
        chartOptions.colors.border = getThemeColor("primary");
    if (!chartOptions.colors.workingHoursNegative)
        chartOptions.colors.workingHoursNegative = getThemeColor("warning");
    if (!chartOptions.colors.workingHoursNormal)
        chartOptions.colors.workingHoursNormal = getThemeColor("primary-alt");
    if (!chartOptions.colors.workingHoursExceeded)
        chartOptions.colors.workingHoursExceeded = getThemeColor("danger");
    if (chartOptions.borderWidth === undefined || isNaN(chartOptions.borderWidth))
        chartOptions.borderWidth = 1;
    chartOptions = sanitizeChartOptions(chartOptions);
    var chart = new ej.charts.Chart({
        primaryXAxis: {
            valueType: 'Category',
            interval: 7,
            visible: chartOptions.xLabelVisible,
            lineStyle: {
                width: 0,
            },
            majorGridLines: {
                width: 0
            },
            minorGridLines: {
                width: 0
            },
            majorTickLines: {
                width: 0
            },
            minorTickLines: {
                width: 0
            },
            labelStyle: {
                fontFamily: FONT_FAMILY
            },
        },
        primaryYAxis: {
            minimum: 0,
            visible: false,
            maximum: chartOptions.dayWorkingTimeInMinutes * 1.5,
            interval: 60,
            valueType: "Double"
        },
        chartArea: {
            border: {
                width: chartOptions.borderWidth,
                color: chartOptions.colors.border
            }
        },
        series: [
            {
                dataSource: chartOptions.chartData,
                xName: 'x',
                yName: 'y',
                type: 'Column',
                animation: {
                    enable: chartOptions.animationEnabled,
                    duration: chartOptions.animationDuration
                },
                name: 'wh',
                cornerRadius: {
                    topLeft: 3,
                    topRight: 3
                },
            }
        ],
        rangeColorSettings: [
            {
                label: `< ${chartOptions.dayWorkingTimeInMinutes - chartOptions.minutesLateTolerance - 1}m`,
                start: 0,
                end: chartOptions.dayWorkingTimeInMinutes - chartOptions.minutesLateTolerance - 1,
                colors: [chartOptions.colors.workingHoursNegative]
            },
            {
                label: `${chartOptions.dayWorkingTimeInMinutes - chartOptions.minutesLateTolerance}m - ${chartOptions.dayWorkingTimeInMinutes}m`,
                start: chartOptions.dayWorkingTimeInMinutes - chartOptions.minutesLateTolerance,
                end: chartOptions.dayWorkingTimeInMinutes * 1.5 - 1,
                colors: [chartOptions.colors.workingHoursNormal]
            },
            {
                label: `!`,
                start: chartOptions.dayWorkingTimeInMinutes * 1.5,
                end: chartOptions.dayWorkingTimeInMinutes * 10,
                colors: [chartOptions.colors.workingHoursExceeded]
            },
        ],
        legendSettings: {
            visible: false,
        },
        dataLabelSettings: {
            visible: true
        },
        tooltip: {
            enable: true,
            template: function (col, chart) {
                var d = Messages.TimeControlChartDaysTooltip.replace("{0}", col.x).replace("{1}", hoursFormatted(col.yValue * 60));
                return `<text class="chart-tooltip">${d}</text>`;
            }
        },
        title: chartOptions.title,
        titleStyle: {
            fontFamily: FONT_FAMILY,
            size: "0.8rem",
            fontWeight: "300",
            color: getThemeColor("secondary")
        },
        highlightMode: 'Point',
        highlightPattern: 'DiagonalForward',
        width: chartOptions.width,
        height: chartOptions.height,
    });
    return chart;
}
function RenderCalendar(calendarOptions) {
    var _a;
    if (!calendarOptions)
        throw "calendarOptions is required for Calendar";
    if (!calendarOptions.resources)
        throw "calendarOptions.resources is required for Calendar";
    if (!calendarOptions.resources.data || calendarOptions.resources.data.length === 0)
        throw "calendarOptions.resources.data is required for Calendar";
    if (!calendarOptions.resources.name)
        throw "calendarOptions.resources.name is required for Calendar";
    if (!calendarOptions.eventData)
        throw "calendarOptions.eventData is required for Calendar";
    if (!calendarOptions.bindingProperty)
        throw "calendarOptions.bindingProperty is required for Calendar";
    if (!calendarOptions.viewMode)
        calendarOptions.viewMode = "TimelineMonth";
    if (!calendarOptions.interval)
        calendarOptions.interval = CALENDAR_DEFAULT_INTERVAL_MONTHS;
    if (!calendarOptions.selectedDate)
        calendarOptions.selectedDate = getFirstDayPastMonth();
    calendarOptions = sanitizeCalendarOptions(calendarOptions);
    var ctorOptions = {
        locale: getLanguage(),
        height: calendarOptions.height,
        width: calendarOptions.width,
        readonly: true,
        enableAdaptiveUI: false,
        rowAutoHeight: true,
        showHeaderBar: true,
        showQuickInfo: calendarOptions.showQuickInfo,
        views: [{
                option: calendarOptions.viewMode,
                interval: calendarOptions.interval,
                eventTemplate: calendarOptions.eventTemplate,
                allowVirtualScrolling: true,
            }],
        group: {
            byGroupID: false,
            resources: [calendarOptions.resources.name],
            headerTooltipTemplate: calendarOptions.resources.tooltipTemplate,
        },
        resourceHeaderTemplate: calendarOptions.resources.headerTemplate,
        resources: [{
                field: calendarOptions.bindingProperty,
                name: calendarOptions.resources.name,
                allowMultiple: true,
                dataSource: calendarOptions.resources.data,
                textField: "Name",
                idField: calendarOptions.bindingProperty,
                colorField: "Color",
            }],
        selectedDate: calendarOptions.selectedDate,
        //scroll: calendarOptions.scrollCallback, // not used by SF schedule component
        eventSettings: {
            dataSource: calendarOptions.eventData,
            fields: {
                subject: {
                    name: "Category"
                }
            },
            enableMaxHeight: true,
            enableTooltip: true,
            enableIndicator: true,
            tooltipTemplate: (_a = calendarOptions.eventSettings) === null || _a === void 0 ? void 0 : _a.tooltipTemplate,
        },
        eventRendered: calendarOptions.eventsRenderedCallback,
        renderCell: calendarOptions.renderCellCallback,
        actionBegin: calendarOptions.actionBeginCallback,
        actionComplete: calendarOptions.actionCompleteCallback,
        dataBound: calendarOptions.dataBoundCallback,
        popupOpen: calendarOptions.popupOpenCallback
    };
    if (calendarOptions.quickInfoTemplates) {
        ctorOptions.quickInfoTemplates = calendarOptions.quickInfoTemplates;
    }
    var calendar = new ej.schedule.Schedule(ctorOptions);
    return calendar;
}
function centerCalendarOnToday(calendar) {
    var currentViewDates = calendar.getCurrentViewDates();
    var todayTime = ej.schedule.resetTime(new Date()).getTime();
    if (ej.schedule.resetTime(currentViewDates[0]).getTime() < todayTime &&
        ej.schedule.resetTime(currentViewDates[currentViewDates.length - 1]).getTime() >= todayTime) {
        calendar.scrollTo(null, new Date());
    }
}
function calendar(calendar) {
    if (calendar) {
        calendar.selectedDate = new Date();
        calendar.scrollTo(null, new Date());
    }
}
function sanitizeCalendarOptions(calendarOptions) {
    if (!calendarOptions)
        calendarOptions = {};
    if (!calendarOptions.resourceHeaderTemplate)
        calendarOptions.resourceHeaderTemplate = "#resource-header-template";
    if (!calendarOptions.eventTemplate)
        calendarOptions.eventTemplate = "#timeline-event-template";
    if (!calendarOptions.headerTooltipTemplate)
        calendarOptions.headerTooltipTemplate = "#resource-header-tooltip-template";
    if (!calendarOptions.quickInfo)
        calendarOptions.quickInfo = false;
    if (!calendarOptions.height)
        calendarOptions.height = "100%";
    if (!calendarOptions.width)
        calendarOptions.width = "100%";
    if (!calendarOptions.eventsRenderedCallback)
        calendarOptions.eventsRenderedCallback = function (args) {
            if (args.data && args.data.Color) {
                var c = args.data.Color;
                if (!c.startsWith("#"))
                    c = "#" + c;
                if (c === "#00000000")
                    c = getThemeColor("body-bg");
                args.element.style.backgroundColor = c;
                args.element.style.opacity = 0.8;
                var cl = colorHtmlToArray(c);
                var fc = getBestForegroundColor(cl);
                args.element.style.color = fc;
            }
        };
    if (!calendarOptions.renderCellCallback) {
        var today = new Date();
        calendarOptions.renderCellCallback = function (args) {
            if (args.elementType === 'monthCells' ||
                args.elementType === 'dateHeader' //||
                //args.elementType === 'emptyCells'
            ) {
                var t, f, cl, b = getThemeColor("modal-content-bg");
                if (isToday(args.date, today)) {
                    t = flattenOpacity(getThemeColor("accent"), b, 0.2);
                    args.element.style.backgroundColor = t;
                }
                else if (args.date.getUTCDate() === 1) {
                    t = flattenOpacity(getThemeColor("primary"), b, 0.3);
                    args.element.style.backgroundColor = t;
                }
                else if (args.date.getUTCDay() === 0 || args.date.getUTCDay() === 6) {
                    t = flattenOpacity(getThemeColor("secondary"), b, 0.1);
                    args.element.style.backgroundColor = t;
                }
                else {
                    cl = colorHtmlToArray(b);
                    f = getBestForegroundColor(cl);
                    args.element.style.color = f;
                }

                if (t && args.elementType === "dateHeader") {
                    cl = colorHtmlToArray(t);
                    f = getBestForegroundColor(cl);
                    args.element.style.color = f;
                }
            }
        };
    }
    if (!calendarOptions.scrollCallback)
        calendarOptions.scrollCallback = null;
    if (!calendarOptions.actionBeginCallback)
        calendarOptions.actionBeginCallback = null;
    if (!calendarOptions.actionCompleteCallback)
        calendarOptions.actionCompleteCallback = null;
    if (!calendarOptions.popupOpenCallback)
        calendarOptions.popupOpenCallback = null;
    if (!calendarOptions.dataBoundCallback)
        calendarOptions.dataBoundCallback = null;
    return calendarOptions;
}
function sanitizeChartOptions(chartOptions) {
    if (!chartOptions)
        chartOptions = {};
    if (!chartOptions.animationDuration)
        chartOptions.animationDuration = 500;
    if (chartOptions.animationEnabled === undefined)
        chartOptions.animationEnabled = true;
    if (!chartOptions.title)
        chartOptions.title = "";
    if (chartOptions.cornerRadius === undefined)
        chartOptions.cornerRadius = 5;
    if (!chartOptions.colors)
        chartOptions.colors = {};
    if (!chartOptions.colors.xAxisLabelColor)
        chartOptions.colors.xAxisLabelColor = getThemeColor("secondary");
    chartOptions.xLabelVisible = !!chartOptions.xLabelVisible;
    if (!chartOptions.colors.yAxisLabelColor)
        chartOptions.colors.yAxisLabelColor = getThemeColor("secondary");
    if (!chartOptions.colors.tooltipColor)
        chartOptions.colors.tooltipColor = getThemeColor("text-light");
    if (!chartOptions.colors.border)
        chartOptions.colors.border = getThemeColor("body-bg");
    chartOptions.legendVisible = !!chartOptions.legendVisible;
    chartOptions.tooltipVisible = !!chartOptions.tooltipVisible;
    if (!chartOptions.width)
        chartOptions.width = "100%";
    if (!chartOptions.height)
        chartOptions.height = "100%";
    if (!chartOptions.centerLabel)
        chartOptions.centerLabel = '';
    if (!chartOptions.colors.centerLabelColor)
        chartOptions.colors.centerLabelColor = getThemeColor("badge-number");
    if (!(chartOptions.borderWidth >= 0 && chartOptions.borderWidth <= 5))
        chartOptions.borderWidth = 0;
    return chartOptions;
}
function clearMap(frameId) {
    var mf = document.getElementById(frameId);
    mf.innerHTML = "";
}
function showLocationOnMap(pos, k, frameId, frameContainer) {
    var { lat, lon } = pos;
    var mapurl = `https://www.google.com/maps/embed/v1/place?key=${k}&q=${lat}%20${lon}&zoom=16`;
    var mf = document.getElementById(frameId);
    var w = window.innerWidth * 0.88, h = window.innerHeight * 0.75;
    if (frameContainer) {
        var dlg = document.querySelector(frameContainer);
        w = dlg.clientWidth - convertRemToPixels(2);
    }
    mf.width = Math.round(w);
    mf.height = Math.round(h);
    mf.classList.remove("d-none");
    mf.src = mapurl;
}
function getFullNameInverted(user) {
    var _a, _b;
    if (!user)
        return null;
    return ((_a = user.LastName) !== null && _a !== void 0 ? _a : "") + (user.LastName ? " " : "") + ((_b = user.FirstName) !== null && _b !== void 0 ? _b : "");
}
function fillObjectCategoryInfo(obj, categories) {
    if (!obj || !categories || !categories.length)
        return;
    var cat = categories.find((x) => x.Id === obj.CategoryId);
    if (!cat)
        return;
    obj.CategoryAccessVacationsInfo = cat.AccessVacationsInfo;
    obj.CategoryAddsToVacations = cat.AddsToVacations;
    obj.CategoryColor = cat.Color;
    obj.CategoryHasLeaveDayLimits = cat.HasLeaveDayLimits;
    obj.CategoryName = cat.Name;
    obj.CategoryRequiresDateRange = cat.RequiresDateRange;
    obj.CategoryRequiresPeriod = cat.RequiresPeriod;
    obj.CategoryRequiresRespApproval = cat.RequiresAuthUnitResponsibleApproval;
}
function fillObjectUserInfo(obj, users) {
    if (!obj || !users || !users.length)
        return;
    var user = users.find((x) => x.Id === obj.UserId);
    if (!user)
        return;
    obj.UserAuthUnitId = user.AuthUnitId;
    obj.UserAuthUnitName = user.AuthUnitName;
    obj.UserCostCenter = user.CostCenter;
    obj.UserEmail = user.Email;
    obj.UserEmployeeNumber = user.EmployeeNumber;
    obj.UserFullName = getFullNameInverted(user);
    obj.UserHireDate = user.HireDate;
    obj.UserHireDateString = user.HireDateString;
    obj.UserPosition = user.Position;
    obj.UserTaxpayerId = user.TaxpayerId;
    obj.UserWorkAgreementId = user.WorkAgreementId;
    obj.UserWorkAgreementName = user.WorkAgreementName;
}
function fillRequestUserInfo(r, users) {
    fillObjectUserInfo(r, users);
    var user = users.find(x => x.Id === r.LastAnswerByUserId);
    if (user)
        r.LastAnswerByUserName = getFullNameInverted(user);
    if (r.FinalStatusSetByUserId) {
        user = users.find(x => x.Id == r.FinalStatusSetByUserId);
        if (user)
            r.FinalStatusSetByUserName = getFullNameInverted(user);
    }
}
function fillLeaveUserInfo(l, users) {
    fillObjectUserInfo(l, users);
    var user = users.find(x => x.Id === l.RegisteredByUserId);
    if (user)
        l.RegisteredByUserFullName = getFullNameInverted(user);
    if (l.LastUpdatedByUserId) {
        user = users.find(x => x.Id == l.LastUpdatedByUserId);
        if (user)
            l.LastUpdatedByUserFullName = getFullNameInverted(user);
    }
}
function fillVacationsUserInfo(v, users) {
    fillObjectUserInfo(v, users);
    var user = users.find(x => x.Id === v.RegisteredByUserId);
    if (user)
        v.RegisteredByUserFullName = getFullNameInverted(user);
    if (v.LastUpdatedByUserId) {
        user = users.find(x => x.Id == v.LastUpdatedByUserId);
        if (user)
            v.LastUpdatedByUserFullName = getFullNameInverted(user);
    }
}
function getObjectIdsByType(objs) {
    if (!objs)
        return {
            userIds: [],
            groupIds: [],
            authUnitIds: []
        };
    return {
        userIds: objs.filter(x => x.Type === SECURITY_PRINCIPAL_USER).map(x => x.Id),
        groupIds: objs.filter(x => x.Type === SECURITY_PRINCIPAL_GROUP).map(x => x.Id),
        authUnitIds: objs.filter(x => x.Type === SECURITY_PRINCIPAL_AUTH_UNIT).map(x => x.Id)
    };
}
async function getUserIdsFromSecurityPrincipalContainer(objs, fetcher, showOvl) {
    var userIds;
    showOvl = !!showOvl;
    if (showOvl)
        showOverlay();
    if (objs && objs.length > 0) {
        if (objs.find(x => x.type !== SECURITY_PRINCIPAL_USER)) {
            const response = await fetcher.fetchJson("/api/site/getobjectsmemberusers", {
                method: 'POST',
                body: JSON.stringify({
                    objects: objs
                })
            });
            if (!response.Result) {
                if (showOvl)
                    hideOverlay();
                showToast(response);
                return;
            }
            userIds = response.Contents.userIds;
        }
        else
            userIds = objs.map((x) => x.id);
    }
    if (!userIds)
        userIds = [];
    return userIds;
}
